import controlArrows from "./controlArrows.js";
import createDOM from "./createDOM.js";
import showMonth from "./showMonth.js";
import showYear from "./showYear.js";
const createYears = (self) => {
  if (self.viewYear === void 0 || !self.dateMin || !self.dateMax)
    return;
  self.currentType = "year";
  createDOM(self);
  showMonth(self);
  showYear(self);
  controlArrows(self);
  const yearsEl = self.HTMLElement.querySelector(`.${self.CSSClasses.years}`);
  if (!yearsEl)
    return;
  if (self.settings.selection.year)
    yearsEl.classList.add(self.CSSClasses.yearsSelecting);
  const templateYearEl = document.createElement("button");
  templateYearEl.type = "button";
  templateYearEl.className = self.CSSClasses.yearsYear;
  for (let i = self.viewYear - 7; i < self.viewYear + 8; i++) {
    const year = i;
    const yearEl = templateYearEl.cloneNode(true);
    if (year === self.selectedYear) {
      yearEl.classList.add(self.CSSClasses.yearsYearSelected);
    }
    if (year < self.dateMin.getFullYear()) {
      yearEl.classList.add(self.CSSClasses.yearsYearDisabled);
      yearEl.tabIndex = -1;
    }
    if (year > self.dateMax.getFullYear()) {
      yearEl.classList.add(self.CSSClasses.yearsYearDisabled);
      yearEl.tabIndex = -1;
    }
    yearEl.dataset.calendarYear = String(year);
    yearEl.innerText = `${year}`;
    yearsEl.append(yearEl);
  }
};
export {
  createYears as default
};
